export const serversList = ['AOC Insurance Broker', 'BOUBYANTAKAFUL'];
export const serverURL = process.env.REACT_APP_ENV=="dev"?"http://127.0.0.1:8000":'https://admin.thinkinsurtech.com:8000';